import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.clients, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_CLIENTS_SNAPSHOT:
      return {
        ...state,
        data: action.clients,
        endBefore: action.endBefore,
        startAfter: action.startAfter
      };
    case ActionTypes.RECEIVE_CLIENTS_TOTAL_COUNT_SNAPSHOT:
      return { ...state, totalCount: action.totalCount };
    case ActionTypes.SET_CLIENTS_SEARCH_CRITERIA:
      return { ...state, ...action.searchCriteria };
    case ActionTypes.SET_CLIENTS_COLUMN_VISIBILITY: {
      return {
        ...state,
        columns: state.columns.map(column => {
          if (column.id === action.column.id) {
            return { ...column, visible: action.column.visible ? false : true };
          }
          return column;
        })
      };
    }
    default:
      return state;
  }
};
